import type {ReactElement} from 'react';
import React from 'react';
import type {RGBA} from '@Utils/color.util';
import {BaseRemoveColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-remove-color-panel';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromEffectsActiveItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveItem';

export function ItemRemoveColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemRemoveColorValue = useGetKeyFromEffectsActiveItem('removeColorValue');

  if (!activeItem || (activeItem && !('effects' in activeItem)) || !activeItemRemoveColorValue) {
    throw new Error(`Item doesn't have effects property`);
  }

  const updateRemoveColor = (removeColorValue: RGBA, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        effects: {
          removeColorValue,
        },
      },
      {undoable}
    );
  };

  return <BaseRemoveColorPanel removeColorValue={activeItemRemoveColorValue} onUpdateRemoveColor={updateRemoveColor} />;
}
